import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { SFBCCNewRequestComponent } from './new-request/new-request.component';
import { SFBCCNewRequestFormService } from './services/new-request-form/new-request-form.service';
import { SingleFamilyBuildingConstructionConversionRoutingModule } from './single-family-building-construction-conversion-routing.module';

@NgModule({
  declarations: [SFBCCNewRequestComponent],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    SingleFamilyBuildingConstructionConversionRoutingModule,
    MatSelectModule,
  ],
  providers: [SFBCCNewRequestFormService],
})
export class SingleFamilyBuildingConstructionConversionModule {}
